import usePageTransitionTracker from './usePageTransitionTracker';

export default usePageTransitionTracker;
